import { Empregabilidade } from '../../types';

export const EMPREGABILIDADE: Empregabilidade[] = [];
